export const PUT_SITES = 'PUT_SITES'

export const PUT_PARTICIPANTS = 'PUT_PARTICIPANTS'

export const PUT_STEP_DATA = 'PUT_STEP_DATA'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_NEW_EXPORTS = 'SET_NEW_EXPORTS'
